import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCompanyByCode } from '../services/companies';
import './CompanyLogin.css';

function CompanyLogin() {
  const [companyCode, setCompanyCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!companyCode.trim()) {
      setError('請輸入公司代碼');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const company = await getCompanyByCode(companyCode);

      if (!company) {
        setError('公司代碼不存在');
        setLoading(false);
        return;
      }

      if (!company.isActive) {
        setError('公司帳號已停用');
        setLoading(false);
        return;
      }

      // 如果有 webhook，需要驗證
      if (company.webhookUrl) {
        // TODO: 實作 webhook 驗證流程
        console.log('Company has webhook, verification needed');
      }

      // 儲存公司資訊到 localStorage
      localStorage.setItem('companyId', company.id);
      localStorage.setItem('companyCode', companyCode);
      localStorage.setItem('companyName', company.companyName);

      // 導航到設備登入頁面
      navigate('/device-login');

    } catch (err) {
      console.error('Company login error:', err);
      setError(err.message || '登入失敗');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="company-login">
      <div className="company-login-container">
        <div className="company-login-header">
          <h1>公司登入</h1>
          <p>請輸入公司代碼以繼續</p>
        </div>

        <form className="company-login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="companyCode">公司代碼</label>
            <input
              id="companyCode"
              type="text"
              className="company-code-input"
              placeholder="輸入公司代碼"
              value={companyCode}
              onChange={(e) => setCompanyCode(e.target.value)}
              disabled={loading}
              autoFocus
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary btn-large"
            disabled={loading}
          >
            {loading ? '驗證中...' : '下一步'}
          </button>
        </form>

        <div className="company-login-footer">
          <p className="help-text">
            如果您沒有公司代碼，請聯繫系統管理員
          </p>
        </div>
      </div>
    </div>
  );
}

export default CompanyLogin;
